import { Backdrop, CssBaseline, Typography } from "@mui/material";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import ADSAppBar from "../components/ADSAppBar";
import ADSNavContent from "../components/ADSNavContent";
import { appBarHeight, navBarWidth } from "../utils/ADSStyles";

const ErrorPage = () => {
  const error = useRouteError();

  if (process.env.NODE_ENV === "development") console.log("[DEBUG] ErrorPage.tsx", error);

  const errorMessage =
    error instanceof Error
      ? error.message
      : isRouteErrorResponse(error)
        ? error.statusText || "This page does not exist."
        : typeof error === "string"
          ? error
          : "An unexpected error occurred.";

  const errorStack = error instanceof Error ? error.stack : undefined;

  return (
    <div style={{ display: "flex" }}>
      <CssBaseline />
      <ADSAppBar />
      <ADSNavContent />
      <main style={{ flexGrow: 1, paddingLeft: `${navBarWidth + 10}px`, paddingRight: "10px" }}>
        <div style={{ height: `${appBarHeight}px` }} />
        <Backdrop open={true} sx={{ flexDirection: "column", gap: 2, p: 4 }}>
          <Typography variant="body1">
            {isRouteErrorResponse(error) ? "This page does not exist." : "An unexpected error occurred."}
          </Typography>
          {process.env.NODE_ENV === "development" && (
            <>
              <Typography variant="body2" sx={{ color: "white", maxWidth: 800, wordBreak: "break-word" }}>
                {errorMessage}
              </Typography>
              {errorStack && (
                <Typography
                  variant="caption"
                  component="pre"
                  sx={{ color: "white", maxWidth: 900, maxHeight: 300, overflow: "auto", textAlign: "left" }}
                >
                  {errorStack}
                </Typography>
              )}
            </>
          )}
        </Backdrop>
      </main>
    </div>
  );
};

export default ErrorPage;
